import { ContactIntegrationStatus } from "@/components/integrations/employee/employee-integrations-sync";
import { Button } from "@/components/ui/button";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useTranslation } from "@/hooks/useTranslation";
import { CrmIntegrationProviderSupported } from "@shaarp/common";
import { Loader2Icon, UserPlusIcon } from "lucide-react";

type CreateNewContactProps = {
  integration: ContactIntegrationStatus;
  onSync: (integrationKey: CrmIntegrationProviderSupported) => void;
};

export const CreateNewContact = ({
  integration,
  onSync,
}: CreateNewContactProps) => {
  const { t } = useTranslation();

  return (
    <DropdownMenuItem disabled className="flex gap-4 items-center px-3 py-3">
      <img
        src={integration.logo}
        alt={integration.name}
        className="object-contain shrink-0 w-6 h-6"
      />
      <div className="flex flex-col flex-1 gap-1">
        <span className="text-sm font-medium">
          {t("employee.integrations.createInIntegration", {
            integration: integration.name,
          })}
        </span>
        <span className="text-xs text-muted-foreground">
          {t("employee.integrations.createNewContact", {
            integration: integration.name,
          })}
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        disabled={integration.isLoading}
        onClick={() => onSync(integration.key)}
        className="p-0 w-8 h-8"
      >
        {integration.isLoading ? (
          <Loader2Icon className="w-4 h-4 animate-spin" />
        ) : (
          <UserPlusIcon className="w-4 h-4" />
        )}
      </Button>
    </DropdownMenuItem>
  );
};
